import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSparkles } from '@fortawesome/pro-solid-svg-icons'
import { Box } from '@material-ui/core'
import { Pill } from '@scoir/pills'

import { getIsUsingMyMatches } from 'components/SegmentSelector/segment-service'
import ReachEstimate from '../ReachEstimate'

type HeaderPillProps = {
  segment: object
  canShowCount: boolean
  loadEstimate: boolean
}

const HeaderPill = ({ segment, canShowCount, loadEstimate }: HeaderPillProps) => {
  const isMyMatchesSelected = getIsUsingMyMatches(segment)
  if (isMyMatchesSelected) {
    return (
      <Pill color="secondary">
        <FontAwesomeIcon icon={faSparkles} />
        <Box ml={0.5}>Scoir Matched</Box>
      </Pill>
    )
  } else {
    return canShowCount ? (
      <ReachEstimate
        loadEstimate={loadEstimate}
        segment={segment}
      />
    ) : null
  }
}

export default HeaderPill
